import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title-popup" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "close" }, null, -1)

import { ref, onMounted } from 'vue';
import usePopup from '@/composables/usePopup'


export default /*#__PURE__*/_defineComponent({
  props: ['articleID', 'parentID'],
  setup(__props) {

const props = __props



let { content, title, show, pos } = usePopup(props.articleID, props.parentID)

// onMounted(() => {
//   if (props.articleID) {
//     fetchContent()
//   }
// })


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "layout-popup",
    style: _normalizeStyle({top:_unref(pos).y+'%',left:_unref(pos).x+'px'})
  }, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(title)), 1),
    _createElementVNode("div", {
      innerHTML: _unref(content),
      class: "inner"
    }, null, 8, _hoisted_2),
    _hoisted_3
  ], 4)), [
    [_vShow, _unref(show)]
  ])
}
}

})